import styled from 'styled-components';
import { Box } from 'components/molecules/utils/basicComponents';

export const InputBox = styled(Box)`
    cursor: pointer;
    padding-right: 20px;
    color: ${({ theme }) => theme.colors.ambience[2]} !important;
    font-family: ${({ theme }) => theme.fonts.book} !important;
    font-size: 14px !important;
`;

export const TimeInputBox = styled(Box)`
    cursor: pointer;
    padding: 16px 16px 15px 20px;
    color: ${({ theme }) => theme.colors.ambience[2]} !important;
    font-family: ${({ theme }) => theme.fonts.book} !important;
    font-size: 14px !important;
`;
